<template>
  <div>
    <div class="row">
      <div class="col-sm"></div>
      <div class="col-md">
        <h2>Login</h2>
      </div>
      <div class="col-sm"></div>
    </div>
    <div class="row">
      <div class="col-sm"></div>
      <div class="col-md">
        <form v-on:submit.prevent="login({username, password})">
          <div class="form-group">
            <label for="txtUsername">Username</label>
            <input type="text" class="form-control" id="txtUsername" v-model="username">
          </div>
          <div class="form-group">
            <label for="txtPassword">Password</label>
            <input type="password" class="form-control" id="txtPassword" v-model="password">
          </div>
          <button type="submit" class="btn btn-hub-primary">Login</button>
        </form>
      </div>
      <div class="col-sm"></div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    login (loginData) {
      this.password = ''
      this.username = ''
      this.$store.dispatch('login', loginData)
    }
  }
}
</script>
